export const tagCategories = [
    'general',
    'series',
    'characters'
] 